import React, { PureComponent } from 'react';
import Raven from 'raven-js';

import { GoogleAd } from '..';
import styles from './styles.scss';

export default class BannerAd extends PureComponent {

  componentDidCatch(error, info) {
    Raven.captureMessage('Caught Google Banner Ad exception', {
      level: 'warning',
      extra: {
        error,
        info
      }
    });
  }

  render() {
    return (
      <GoogleAd className={ styles.bannerAd } />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BannerAd/index.jsx